export const screenSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="46" height="37">
  <g fill="none" fill-rule="evenodd">
    <circle cx="23" cy="25" r="1" stroke="#FFF"/>
    <rect width="39" height="24" x="3.5" y="4.5" stroke="#FFF" rx="2"/>
    <path fill="#FFF" d="M3 21h40v1H3z"/>
    <path stroke="#FFF" d="M17.196 28.5a.5.5 0 0 0-.464.315l-1.197 3A.5.5 0 0 0 16 32.5h13a.5.5 0 0 0 .464-.685l-1.196-3a.5.5 0 0 0-.464-.315H17.196z"/>
  </g>
</svg>
`;
